import { render, staticRenderFns } from "./widgets.vue?vue&type=template&id=50138627&scoped=true"
import script from "./widgets.vue?vue&type=script&lang=js"
export * from "./widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50138627",
  null
  
)

export default component.exports